'use client';

import { Logo } from '@/components/ui/logo';
import { Footer } from './footer';
import { HeroAtmosphere } from './hero-atmosphere';

interface AuthLayoutProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

export function AuthLayout({ children, title, subtitle }: AuthLayoutProps) {
  return (
    <div className="min-h-dvh flex flex-col relative overflow-hidden">
      <HeroAtmosphere />

      {/* Header */}
      <header className="relative z-10 py-6 w-full border-white/5 border-b">
        <div className="account-container">
          <Logo size="md" linkTo="/" />
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 flex-1 flex items-start justify-center px-4 py-6">
        <div className="w-full max-w-[480px]">
          {/* Solid Dark Card - Compact Supabase Style */}
          <div className="rounded-xl py-8 px-5">
            {/* Title */}
            {title && (
              <div className="text-center mb-5">
                <h1 className="text-xl font-semibold text-text-primary">{title}</h1>
                {subtitle && <p className="mt-1.5 text-sm text-text-secondary">{subtitle}</p>}
              </div>
            )}

            {/* Form Content */}
            {children}
          </div>
        </div>
      </main>

      {/* Footer */}
      <div className="relative z-10">
        <Footer classNameDivContainer="account-container" />
      </div>
    </div>
  );
}
